
import { useScrollAnimation, getAnimationClass } from '../../../hooks/useScrollAnimation';

function AnimatedSection({ children, animation = 'slide-up' as 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in', delay = 0, className = '' }: { children: React.ReactNode; animation?: 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in'; delay?: number; className?: string }) {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <div ref={ref} className={`${getAnimationClass(isVisible, animation, delay)} ${className}`}>
      {children}
    </div>
  );
}

export default function Reasons() {
  const reasons = [
    {
      icon: 'ri-speed-line',
      title: 'Implementación en 48 horas',
      description: 'Configura tu cuenta, migra tus datos y comienza a usar Anamnesy Soft en menos de dos días con nuestro equipo de soporte dedicado.',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'ROI desde el primer mes',
      description: 'Reduce costos operativos y aumenta la productividad de tu consulta desde la primera semana de uso.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Soporte 24/7 especializado',
      description: 'Equipo de soporte que entiende oftalmología. Resolvemos tus dudas técnicas y clínicas en minutos.',
    },
    {
      icon: 'ri-cloud-line',
      title: '100% en la nube',
      description: 'Accede desde cualquier dispositivo, en cualquier lugar. Sin instalaciones, sin servidores, sin complicaciones.',
    },
    {
      icon: 'ri-glasses-line',
      title: 'Módulo de Óptica incluido',
      description: 'Gestiona monturas, lentes, inventario y ventas de tu óptica integrado directamente con los historiales clínicos.',
    },
    {
      icon: 'ri-lock-line',
      title: 'Seguridad de grado médico',
      description: 'Encriptación AES-256, cumplimiento HIPAA y respaldos automáticos para proteger los datos de tus pacientes.',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-emerald-600 to-emerald-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <AnimatedSection animation="fade-in">
          <div className="text-center mb-16">
            <span className="inline-block text-xs font-semibold text-emerald-200 uppercase tracking-widest mb-3">¿Por qué elegirnos?</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              6 razones para elegir <span className="font-display italic">Anamnesy Soft</span>
            </h2>
            <p className="text-sm text-white/80 max-w-lg mx-auto">
              Profesionales de la salud visual confían en nosotros para transformar su práctica diaria.
            </p>
          </div>
        </AnimatedSection>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((reason, index) => (
            <AnimatedSection key={index} animation="scale-in" delay={index * 100}>
              <div className="bg-white/10 backdrop-blur-sm p-7 rounded-xl border border-white/15 hover:bg-white/15 transition-all cursor-pointer group h-full">
                <div className="w-11 h-11 bg-white/20 rounded-lg flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                  <i className={`${reason.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-base font-bold text-white mb-2">{reason.title}</h3>
                <p className="text-sm text-white/80 leading-relaxed">{reason.description}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
